const jwt_claims = {
    title: 'Пользовательский JWT',
    description: 'Персонализируйте токен доступа или ID-токен, предоставляя дополнительную информацию вашему приложению.',
    access_token: {
        card_title: 'Токен доступа',
        card_description: 'Токен доступа — это учетные данные, используемые API для авторизации запросов, содержащие только необходимые утверждения для решений о доступе.',
    },
    user_jwt: {
        card_field: 'Токен доступа пользователя',
        card_description: 'Добавление специфичных для пользователя данных во время выдачи токена доступа.',
        for: 'для пользователя',
    },
    machine_to_machine_jwt: {
        card_field: 'Токен доступа от машины к машине',
        card_description: 'Добавление дополнительных данных во время выдачи токена от машины к машине.',
        for: 'для М2М',
    },
    id_token: {
        card_title: 'ID-токен',
        card_description: 'ID-токен — это подтверждение личности, полученное после входа, содержащее утверждения о личности пользователя, которые клиент может использовать для отображения или создания сеанса.',
        card_field: 'ID-токен пользователя',
        card_field_description: "Утверждения 'sub', 'email', 'phone', 'profile' и 'address' всегда доступны. Другие утверждения необходимо сначала включить здесь. Во всех случаях ваше приложение должно запросить соответствующие области действия при интеграции, чтобы получить их.",
    },
    code_editor_title: 'Настройка своих утверждений {{token}}',
    custom_jwt_create_button: 'Добавить пользовательские утверждения',
    custom_jwt_item: 'Пользовательские утверждения {{for}}',
    delete_modal_title: 'Удалить пользовательские утверждения',
    delete_modal_content: 'Вы уверены, что хотите удалить пользовательские утверждения?',
    clear: 'Очистить',
    cleared: 'Очищено',
    restore: 'Восстановить по умолчанию',
    restored: 'Восстановлено',
    data_source_tab: 'Источник данных',
    error_handling_tab: 'Обработка ошибок',
    test_tab: 'Тестовый контекст',
    jwt_claims_description: 'Утверждения по умолчанию автоматически включаются в JWT и не могут быть переопределены.',
    user_data: {
        title: 'Данные пользователя',
        subtitle: 'Используйте параметр ввода `context.user` для предоставления важной информации о пользователе.',
    },
    grant_data: {
        title: 'Данные предоставления',
        subtitle: 'Используйте параметр ввода `context.grant` для предоставления важной информации о предоставлении, доступной только для обмена токенами.',
    },
    interaction_data: {
        title: 'Контекст взаимодействия с пользователем',
        subtitle: 'Используйте параметр `context.interaction` для доступа к деталям взаимодействия пользователя для текущей сессии аутентификации.',
    },
    application_data: {
        title: 'Контекст приложения',
        subtitle: 'Используйте входной параметр `context.application` для предоставления информации о приложении, связанной с токеном.',
    },
    organization_data: {
        title: 'Контекст организации',
        subtitle: 'Используйте входной параметр `context.organization` для предоставления информации о целевой организации, доступно только для токенов организации.',
    },
    token_data: {
        title: 'Данные токена',
        subtitle: 'Используйте параметр ввода `token` для полезной нагрузки текущего токена доступа. ',
    },
    api_context: {
        title: 'Контекст API: управление доступом',
        subtitle: 'Используйте метод `api.denyAccess` для отклонения запроса токена.',
    },
    error_handling: {
        title: 'Обработка ошибок',
        subtitle: 'Определяет, следует ли блокировать выдачу токена при сбое скрипта.',
        input_field_title: 'Поведение выдачи токена при ошибке скрипта',
        block_issuance_switch: 'Блокировать выдачу токена, если скрипт завершился с ошибкой',
        default_hint_create: 'Для новых скриптов пользовательских claims по умолчанию включается блокировка выдачи токена при ошибке скрипта. Если API уже возвращает значение, вместо этого используется сохраненное значение.',
        default_hint_edit: 'Существующие скрипты пользовательских claims без этой настройки сохраняют прежнее поведение с выключенной опцией по умолчанию, пока вы явно не сохраните значение.',
        warning: 'Если включено, ошибки выполнения скрипта отклоняют запрос токена с `invalid_request` (400) и локализованным `error_description`. Вызовы `api.denyAccess` по-прежнему возвращают `access_denied`.',
    },
    fetch_external_data: {
        title: 'Получение внешних данных',
        subtitle: 'Интегрирование данных непосредственно из ваших внешних API в утверждения.',
        description: 'Используйте функцию `fetch` для вызова ваших внешних API и включения данных в ваши пользовательские утверждения. Пример: ',
    },
    environment_variables: {
        title: 'Установка переменных среды',
        subtitle: 'Используйте переменные среды для хранения конфиденциальной информации.',
        input_field_title: 'Добавить переменные среды',
        sample_code: 'Доступ к переменным среды в вашем обработчике утверждений JWT. Пример: ',
    },
    jwt_claims_hint: 'Ограничьте пользовательские утверждения до 50 КБ. Утверждения по умолчанию JWT автоматически включаются в токен и не могут быть переопределены.',
    tester: {
        subtitle: 'Настройте макетный токен и данные пользователя для тестирования.',
        run_button: 'Запустить тест',
        result_title: 'Результат теста',
    },
    form_error: {
        invalid_json: 'Недопустимый формат JSON',
    },
};
export default Object.freeze(jwt_claims);
